/*
  Cart drawer extras — Lily & June (operator 25-10-2026: drawer 1:1 like Sableau)
  ------------------------------------------------------------
  Port of Sableau's live assets/cart-savings.js, on top of the Essential Cart Drawer app:
    1) green "(Save $X)" after the sale price of every line, from the two prices already on screen;
    2) (Sableau hides Subtotal and writes the total on the button; LJ keeps its Subtotal row and the app's own button text, 27-10)
    3) "Complete the look" swipe row of best-seller cards under the line items (<template id="lj-dup">
       in layout/theme.liquid), replacing Essential's own upsell row; a card leaves once its piece is in the cart.
  Left out on purpose: Sableau's euro and free-gift texts (LJ sells in USD and keeps its quantity bar)
  and the store-credit line (operator: not on LJ).
    4) "incl. extra 25% off" next to Savings once Shopify's quantity discount applies (operator 27-10), from the cart's
       own discount allocations, so it always shows what checkout really takes off.
  Hooks: the drawer's stable data-essential-cart-element attributes. Essential re-renders the drawer, so every pass re-applies.
*/
(function () {
  if (window.__ljCartSavingsLoaded) return;
  window.__ljCartSavingsLoaded = true;

  var STYLE = '.sb-save{color:#0a8a4a;font-weight:600;font-size:.85em;margin-left:.35em;white-space:nowrap}'
    + '.lj-extra{display:inline-block;margin-left:.5em;padding:2px 7px;border-radius:999px;background:#0a8a4a;color:#fff;font-size:.72em;font-weight:700;letter-spacing:.03em;vertical-align:1px;white-space:nowrap}'
    // Same row as Sableau's: 3 cards + a quarter of the 4th in view, so it reads as swipeable.
    + '.sb-dup{padding:14px 0 14px 16px;border-top:1px solid #ececec}.sb-dup__t{margin:0 16px 8px 0;font-size:15px;font-weight:700;line-height:1.3;color:#111;text-transform:none;letter-spacing:0}'
    + '.sb-dup__r{display:flex;gap:8px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch}.sb-dup__r::-webkit-scrollbar{display:none}'
    + '.lj-dup{position:relative;flex:0 0 calc((100% - 24px) / 3.25);scroll-snap-align:start}.lj-dup[hidden]{display:none}'
    + '.lj-dup__media{display:block;position:relative;aspect-ratio:3/4;background:#f5f5f5;overflow:hidden}.lj-dup__media img{width:100%;height:100%;object-fit:cover;display:block}'
    + '.lj-dup__off{position:absolute;top:4px;right:4px;background:#111;color:#fff;font-size:10px;font-weight:700;line-height:1;padding:2px 4px;border-radius:4px;pointer-events:none}'
    + '.lj-dup__media>a{display:block;height:100%}'
    + '.lj-dup__add{position:absolute;right:5px;bottom:5px;z-index:2;width:30px;height:30px;padding:5px;border:0;border-radius:50%;background:#111;color:#fff;display:grid;place-items:center;cursor:pointer}'
    + '.lj-dup__add svg{width:20px;height:20px}.lj-dup__add[disabled]{opacity:.5}'
    + '.lj-dup__title{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;margin-top:6px;font-size:12px;line-height:15px;color:#111;text-decoration:none;text-transform:none;letter-spacing:0}'
    + '.lj-dup__price{font-size:13px;line-height:18px;margin:0;font-weight:600;color:#111}.lj-dup__price s{font-size:11px;font-weight:400;color:#888;margin-left:4px}';

  // "$44.95" · "A$69.95" · "1,234.50"
  var PRICE_RE = /^\s*(?:[^\d\s]{0,4}\s?)?\d[\d.,\s ]*(?:\s?[^\d\s]{0,4})?\s*$/;

  function leafText(el) {
    if (el.children.length) return null;
    var t = (el.textContent || '').replace(/ /g, ' ').trim();
    if (!t || t.length > 24 || !/\d/.test(t) || !PRICE_RE.test(t)) return null;
    return t;
  }

  function parseCents(str) {
    var num = str.replace(/[^\d.,]/g, '');
    var m = num.match(/^(.*?)([.,])(\d{2})$/);
    var intPart = (m ? m[1] : num).replace(/[.,]/g, '');
    var dec = m ? m[3] : '00';
    if (!intPart && !m) return null;
    return { cents: parseInt(intPart || '0', 10) * 100 + parseInt(dec, 10), decSep: m ? m[2] : null };
  }

  function formatLike(sample, cents) {
    var m = sample.match(/^(\D*?)(\d[\d.,\s ]*\d|\d)(\D*)$/);
    if (!m) return null;
    var prefix = m[1], numStr = m[2], suffix = m[3];
    var parsed = parseCents(numStr);
    var decSep = (parsed && parsed.decSep) || (numStr.indexOf(',') >= 0 ? ',' : '.');
    var thouSep = '';
    var head = numStr.replace(/[.,]\d{2}\s*$/, '');
    var t = head.match(/[.,\s ]/);
    if (t) thouSep = t[0];
    var whole = Math.floor(cents / 100);
    var frac = String(cents % 100);
    if (frac.length < 2) frac = '0' + frac;
    var ws = String(whole);
    if (thouSep) ws = ws.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    if (!(parsed && parsed.decSep) && cents % 100 === 0) return prefix + ws + suffix;
    return prefix + ws + decSep + frac + suffix;
  }

  var ITEM = '[data-essential-cart-element="cart-drawer-item"]';
  var REG = '[data-essential-cart-element="line-item-regular-price"]';
  var DISC = '[data-essential-cart-element="line-item-discounted-price"]';

  // 1) "(Save $X)" after the discounted price of every drawer line item.
  function apply() {
    var items = document.querySelectorAll(ITEM);
    for (var i = 0; i < items.length; i++) {
      var reg = items[i].querySelector(REG);
      var disc = items[i].querySelector(DISC);
      if (!reg || !disc) continue;
      var regTxt = leafText(reg) || (reg.textContent || '').trim();
      var discTxt = leafText(disc) || (disc.textContent || '').trim();
      var a = parseCents(regTxt), b = parseCents(discTxt);
      var existing = disc.parentElement && disc.parentElement.querySelector(':scope > .sb-save');
      if (!a || !b || a.cents <= b.cents) { if (existing) existing.remove(); continue; }
      var label = formatLike(discTxt, a.cents - b.cents);
      if (!label) continue;
      var text = '(Save ' + label + ')';
      if (existing) { if (existing.textContent !== text) existing.textContent = text; continue; }
      var span = document.createElement('span');
      span.className = 'sb-save';
      span.textContent = text;
      disc.parentElement.insertBefore(span, disc.nextSibling);
    }
  }

  // 3) "Complete the look" row under the line items.
  function addonRow() {
    var tpl = document.getElementById('lj-dup');
    var list = document.querySelector('[data-essential-cart-element="cart-drawer-item-list-wrapper"]');
    var row = document.querySelector('.sb-dup');
    if (!tpl || !list) return;
    var items = document.querySelectorAll(ITEM), inCart = '';
    for (var i = 0; i < items.length; i++) inCart += ' ' + (items[i].textContent || '');
    if (!items.length) { if (row) row.remove(); return; }
    if (!row) row = tpl.content.firstElementChild.cloneNode(true);
    var cards = row.querySelectorAll('[data-lj-dup]'), left = 0;
    for (var j = 0; j < cards.length; j++) {
      var name = cards[j].getAttribute('data-title') || '';
      var gone = !!name && inCart.indexOf(name) > -1;
      if (cards[j].hidden !== gone) cards[j].hidden = gone;
      if (!gone) left++;
    }
    if (!left) { row.remove(); return; }
    if (row.previousElementSibling !== list) list.parentNode.insertBefore(row, list.nextSibling);
  }

  // 4) "incl. extra N% off" next to Savings: the highest automatic percentage discount on the cart lines.
  function extraNote() {
    var label = document.querySelector('[data-essential-cart-element="discount-code-savings-label"]');
    var api = window.essentialCartApi, d = api && api.getCartData && api.getCartData();
    if (!label || !d || !d.items) return;
    var pct = 0;
    d.items.forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (a) { var x = a.discount_application || {}; if (x.value_type === 'percentage' && +x.value > pct) pct = Math.round(+x.value); }); });
    var tag = label.querySelector('.lj-extra'), text = 'incl. extra ' + pct + '% off';
    if (!pct) { if (tag) tag.remove(); return; }
    if (!tag) { tag = document.createElement('span'); tag.className = 'lj-extra'; label.appendChild(tag); }
    if (tag.textContent !== text) tag.textContent = text;
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; try { apply(); } catch (e) {} try { addonRow(); } catch (e) {} try { extraNote(); } catch (e) {} }, 150);
  }

  function start() {
    var css = document.createElement('style');
    css.textContent = STYLE;
    if (document.getElementById('lj-dup')) document.documentElement.classList.add('sb-has-dup');
    (document.head || document.documentElement).appendChild(css);
    schedule();
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if ((muts[i].addedNodes && muts[i].addedNodes.length) || muts[i].type === 'characterData') { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
    var n = 0;
    var timer = setInterval(function () { schedule(); if (++n > 20) clearInterval(timer); }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
